import { z } from "zod";

export const AUDIO_QUALITY_SCOPE =
  "Incoming audio before agent noise cancellation: signal levels only, not speech intelligibility or Val's voice.";
export const AUDIO_QUALITY_NOT_SCORED = "This evaluation has no incoming-audio assessment.";

export const audioQualityAssessmentSchema = z.object({
  rubricVersion: z.union([z.literal(1), z.literal(2)]),
  score: z.number().int().min(1).max(5).nullable(),
  explanation: z.string().min(1),
});

export type AudioQualityAssessment = z.infer<typeof audioQualityAssessmentSchema>;
